import type { V3 } from "@project-rouge/rg-core";
import { RgDataSetID } from "@project-rouge/rg-core";
import { RewindPolygonAnticlockwise } from "src/utils/RewindPolygonAnticlockwise";
import { World } from "src/types/World";
import { Zone } from "src/types/Zone";

// Generic counterpart to CreateBoxWorld for arbitrary planar footprints.
// Same brief defaults (one building, N residential floors, dataset-default
// unit mix); same anticlockwise-rewind hygiene around the polygon.
export function CreatePolyWorld(
  polygon: readonly V3[],
  floors: number,
  datasetId?: RgDataSetID
): World {
  const world = new World(datasetId ? { rgDatasetId: datasetId } : undefined);
  const zone = new Zone();
  zone.setOuterRing(RewindPolygonAnticlockwise([...polygon]));
  zone.brief.buildingCount = 1;
  zone.brief.setResidentialFloorCount(floors);
  world.addZone(zone);
  return world;
}
